module.exports = __webpack_public_path__ + "img/checked_off.5becc03e.svg";